import { useState } from "react";
import axios from "axios";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { API_BASE_URL } from "../../config/api";
import "../RegPulseLinkExpire/RegPulseLinkExpire.css";
import "../Home/Components/HomeBanner.css";

const VerifyMail = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = params.token || searchParams.get("token") || "";
  const [isVerifying, setIsVerifying] = useState(false);
  const [message, setMessage] = useState("");

  const handleVerify = async () => {
    if (!token) {
      setMessage("Invalid verification link. Token is missing.");
      return;
    }

    try {
      setIsVerifying(true);
      setMessage("");
      const response = await axios.post(`${API_BASE_URL}/verifyEmail`, null, {
        params: { token },
      });

      if (String(response.data?.code) === "200" && response.data?.status === "SUCCESS") {
        navigate("/regpulsesignupactivation");
        return;
      }

      setMessage("Unable to verify your email. Please try again.");
      navigate("/regpulselinkexpire");
      
    } catch (error) {
      console.error("Error verifying email:", error);
      setMessage(
        axios.isAxiosError(error)
          ? error.response?.data?.message || "Unable to verify your email. Please try again."
          : "Unable to verify your email. Please try again."
      );
    } finally {
      setIsVerifying(false);
    }
  };

  return (
    <section className="regpulse-expire-page">
      <div className="regpulse-expire-content">
        <p className="regpulse-expire-eyebrow">EvoNext RegPulse</p>
        <h1>Verify your email address</h1>
        <p className="regpulse-expire-message">
          Click the button below to verify your email address and activate your RegPulse subscription.
        </p>
        <button
          type="button"
          className="regpulse-expire-button getintouchbtn"
          onClick={handleVerify}
          disabled={isVerifying}
        >
          {isVerifying ? "Verifying..." : "Verify email"}
        </button>
        {message && <p className="regpulse-expire-message" role="alert">{message}</p>}
        {/* <Link to="/home" className="regpulse-expire-back">
          &lt; Back to www.evonext.ai
        </Link> */}
      </div>
    </section>
  );
};

export default VerifyMail;
